// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationPageContainerStyles } from "@awc/Overrides/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.headerGridItem = {
    width: 12,
};
orderConfirmationPageContainerStyles.orderInformationGridItem = {
    width: 12,
};
orderConfirmationPageContainerStyles.orderTotalGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &&&& {
            margin-left: auto;
            @media print {
                float: right;
            }
        }
    `,
};

orderConfirmationPageContainerStyles.productListGridItem = {
    width: 12,
};
orderConfirmationPageContainerStyles.actionsGridItem = {
    width: 12,
};
orderConfirmationPageContainerStyles.container = {
    gap: 24,
};
